const OPTIMIZABLE_REMOTE = /^https:\/\/[a-z0-9-]+\.cdn\.modulify\.website\//i

/**
 * True for local images and files on the site's own storage CDN, which next/image can resize.
 * Anything else (a link pasted into the CMS from another site) is rendered as-is.
 */
export const isOptimizable = (src: string): boolean => {
    return src.startsWith('/') || OPTIMIZABLE_REMOTE.test(src)
}
